import { Toast as BaseToast } from '@base-ui/react/toast'
import { ToastAction } from './nested/action'
import { ToastClose } from './nested/close'
import { ToastDescription } from './nested/description'
import { ToastIcon } from './nested/icon'
import { ToastProvider } from './nested/provider'
import { ToastRoot } from './nested/root'
import { useToast } from './nested/use-toast'
import { ToastViewport } from './nested/viewport'

export type { ToastTone } from './nested/tones'
export type { ShowToast, ToastActionOptions, ToastHandle, ToastOptions } from './nested/use-toast'
export { toasterFor } from './nested/use-toast'

/** One toast surface. Most callers only need `Toast.Provider` and `Toast.useToast()`. */
const Toast = Object.assign(ToastRoot, {
  Provider: ToastProvider,
  Viewport: ToastViewport,
  Icon: ToastIcon,
  Description: ToastDescription,
  Action: ToastAction,
  Close: ToastClose,
  useToast,
  createToastManager: BaseToast.createToastManager,
})

export { Toast }
